import { unionBy } from 'lodash-es';
import { getEnv } from './env';

/**
 * 获取路由query参数
 * @param query 传入的query参数
 * @returns {{}}
 */
export const getHashQuery = (query = window.location.href?.split('?')?.[1] || ''): Record<string, any> => {
  const reg = /([^=&\s]+)[=\s]*([^&\s]*)/g;
  const obj: any = {};
  while (reg.exec(query)) obj[RegExp.$1] = RegExp.$2;
  return obj;
};

export const getHost = () => {
  if (window.location.origin.indexOf('localhost') === -1){
    return window.location.origin;
  }
  // const { VUE_APP_QW_SCRM_BASE_URL } = getEnv();
  //  return 'http://localhost:3001';

  const { VUE_APP_QW_SCRM_BASE_URL } = getEnv();
  return VUE_APP_QW_SCRM_BASE_URL;

};

export const getAdClickId = (urlParam: {[key:string]: string}) => {
  // 腾讯广告-微信流量获取clickid的参数: gdt_vid
  // 腾讯广告-非微信流量获取clickid的参数: qz_gdt
  // 巨量广告-微信流量获取clickid的参数: clickid
  let clickId = urlParam['gdt_vid'] || urlParam['qz_gdt'] || urlParam['clickid'] || '';
  if (clickId === '__CLICKID__'){ // 过滤非法的clickId值
    clickId = '';
  }
  return clickId;
};

// 需要通过活码、表单提交接口给广告后端的参数 see https://doc.weixin.qq.com/doc/w3_AVwASwbdABQYUFkISoYStyvN83iNb?scode=ACUArAcBAAkm6ZsG8oAVwASwbdABQ
const dou_yin = ['adv_id', 'adv_name', 'promotion_id', 'promotion_name', 'projectid', 'ad_id', 'ad_name', 'creative_id', 'external_url', 'click_id', 'siteId'];
const tencent = [
  'account_id',
  'adgroup_id',
  'adgroup_name',
  'campaign_id',
  'campaign_name',
  'ad_id',
  'ad_name',
  'page_url',
  'click_id',
  'siteId',
  'adId',
  'scene',
  'click_time',
  'ad_platform_type',
  'ad_type',
  'callback',
  'wechat_openid',
  'wechat_account_id'
];
const other = ['creativetype', 'sourceadid']; // 1.10 的参数一起搞过来

// 由于参数可能拼接在？后，也可能拼接在#后，因此用两种方式都获取一遍参数，并将有效值存起来
export const getAdUrlParams = (searchParams: {[key:string]: string}, routerQuery: {[key:string]: string}) => {
  try {
    const resData: Array<Record<string, string>> = [];
    const siteParams: {column_name: string, column_value: string}[] = [];
    const searchKeys = Object.keys(searchParams);
    searchKeys.forEach(k => {
      siteParams.push({
        column_name: k,
        column_value: searchParams[k]
      });
    });

    const queryKeys = Object.keys(routerQuery);
    queryKeys?.forEach(k => {
      siteParams.push({
        column_name: k,
        column_value: routerQuery[k]
      });
    });

    // 统一格式 用于匹配 site_id => siteid siteId => siteid SiteId => siteid
    const standardFormat = (key: string) => key.replace(/_/g, '').toLowerCase();

    // 构造接口需要的参数
    [...dou_yin, ...tencent, ...other].forEach(key => {
      // 把key 的下划线去掉 并且全部转成小写 统一参数格式去匹配 因为两边参数格式都不是统一的
      const data = siteParams.find(item => standardFormat(item.column_name) === standardFormat(key));
      // 存在数据才添加
      if (data) {
        resData.push({
          column_name: key, // 这里就要用文档的 key 了 转换的 key 只是为了匹配
          column_value: data.column_value
        });
      }
    });

    return unionBy(resData, 'column_name');
  } catch (error) {
    return [];
  }
};

export const safeJsonStringify = (value: any) => {
  try {
    return JSON.stringify(value);
  } catch (error) {
    return '';
  }
};